var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "spnod-admin__form--container container mx-0 w-100 h-100",
    class: _vm.isMobile ? 'px-0' : 'px-3'
  }, [_c('div', {
    staticClass: "spnod-admin__form--main d-flex align-items-center flex-column",
    attrs: {
      "id": "login-main"
    }
  }, [_c('h3', {
    staticClass: "h3 mb-4"
  }, [_vm._v("Unsubscribe")]), _vm._v(" "), (_vm.unsubscribed === false) ? _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v("Please be aware by unsubscribing from emails, you will not be notified of unread messages moving forward. If you decide to unsubscribe, it will be your responsibility to login and check for unread messages within the app.")]), _vm._v(" "), _c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.unsubscribe()
      }
    }
  }, [_vm._v("\n          Unsubscribe\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.unsubscribed === true) ? _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_vm._v("You have been unsubscribed. Please remember to check back in for new messages from time to time.")]), _vm._v(" "), _c('router-link', {
    staticClass: "text-center",
    attrs: {
      "to": {
        name: 'messages'
      }
    }
  }, [_vm._v("\n          View Messages\n        ")])], 1) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4b2d81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AdminAuth/Unsubscribe.vue
// module id = z2aP
// module chunks = 2